import React, { createRef, useContext, useEffect, useRef, useState } from 'react';
import { ThemeContext } from '../../context/theme-context';
import { widget } from '../../assets/charting_library-master/charting_library';
import TradingViewChartFeeder from '../../assets/charting_library-master/TradingViewChartFeeder';
import Streaming from '../../services/_realtime/price/Streaming';
import './tradingViewWidget.scss';
import Modal from 'react-bootstrap/Modal';
import { Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { faCircleXmark, faSearch, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Search from '../search/search';
import { icon } from '@fortawesome/fontawesome-svg-core';
import Spinner from '../spinner';

const chart_interval = 'D';

export default function TradingViewWidget(props) {  // props: {symbolCode}
    const streamingRef = useRef(null);
    const onLoadScriptRef = useRef();
    const [theme, setTheme] = useState('dark'); // ['dark', 'light'
    const currentTheme = useContext(ThemeContext).theme;
    const chartContainerRef = useRef();
    const chartRef = useRef();
    const divRef = useRef(null);  // React ref oluştur

    const tvWidgetRef = useRef(null);
    const [isLoadingTable, setIsLoadingTable] = useState(true);
    const handleClose = () => setVisible(false);
    const [searchValue, setSearchValue] = useState("");
    const [visible, setVisible] = useState(false);
    const searchInputRef = useRef(null);
    const [isFocused, setIsFocused] = useState(false);

    let focus = false;
    useEffect(() => {
        streamingRef.current = new Streaming();
    }, []);

    useEffect(() => {
        if (visible) {
            searchInputRef.current.focus();
        }
    }, [visible]);

    useEffect(
        () => {
            setTheme(currentTheme);

            const Streaming_ = new Streaming();

            let studiesoverrides = {
                'volume.volume ma.plottype': 'line',
                'volume.volume.color.0': 'rgba(255, 81, 81, .4)',
                'volume.volume.color.1': 'rgba(101,189,88,.4)',
                'volume.show ma': true,
            };

            let overrides = {
                "volumePaneSize": 'small',
                'mainSeriesProperties.style': 1,

                'mainSeriesProperties.candleStyle.upColor': '#65BD58',
                'mainSeriesProperties.candleStyle.downColor': '#FF5151',

                'mainSeriesProperties.barStyle.upColor': '#65BD58',
                'mainSeriesProperties.barStyle.downColor': '#FF5151',

                'scalesProperties.textColor': '#000',
            };

            //   this.tp.check2themeType() == 'dark'

            if (theme === 'dark') {
                overrides = {
                    'paneProperties.background': '#2c2c2c',
                    'paneProperties.vertGridProperties.color': '#303030',
                    'paneProperties.horzGridProperties.color': '#303030',
                    'paneProperties.crossHairProperties.color': '#C17211',
                    'mainSeriesProperties.candleStyle.upColor': '#65BD58',
                    'mainSeriesProperties.candleStyle.downColor': '#FF5151',
                    'mainSeriesProperties.barStyle.upColor': '#65BD58',
                    'mainSeriesProperties.barStyle.downColor': '#FF5151',
                    'scalesProperties.textColor': '#eff0f1',
                    "mainSeriesProperties.showCountdown": true,

                };
            }
            const datafeed = new TradingViewChartFeeder(streamingRef.current);

            const widgetOptions = {
                datafeed: datafeed,
                symbol: "null",
                interval: chart_interval,
                container: chartContainerRef.current,
                library_path: "/charting_library-master/charting_library/",
                locale: 'tr',
                disabled_features: ['symbol_search_hot_key', 'header_symbol_search', 'side_toolbar_in_fullscreen_mode', 'link_to_tradingview', 'display_market_status', 'header_layouttoggle', 'volume_force_overlay', 'header_symbol_search', 'header_compare', 'header_saveload', 'header_screenshot', 'countdown', 'chart_property_page_timezone_sessions', 'symbol_info', 'border_around_the_chart', 'adaptive_logo', 'use_localstorage_for_settings', 'study_templates', 'header_settings', 'go_to_date', 'header_quick_search'],
                enabled_features: ['show_logo_on_all_charts'],
                client_id: 'tradingview.com',
                user_id: 'public_user_id',
                theme: theme === 'dark' ? 'Dark' : 'Light',
                loading_screen: {
                    foregroundColor: theme == 'dark' ? '#c17211' : '#21618c',
                    backgroundColor: theme == 'dark' ? '#292929' : '#ffffff',
                },
                studies_overrides: studiesoverrides,
                overrides: overrides,
                container_id: "tradingview_3fe4f",

                // custom_css_url: '../themed.css',
                time_frames: [
                    { text: '1M', resolution: chart_interval, description: '1 Month' },
                    { text: '3M', resolution: chart_interval, description: '3 Month' },
                    { text: '6M', resolution: chart_interval, description: '6 Month' },
                    { text: '1Y', resolution: chart_interval, description: '1 Year' },
                    { text: '2Y', resolution: chart_interval, description: '2 Years' },
                    { text: '3Y', resolution: chart_interval, description: '3 Years' },
                    { text: '5Y', resolution: chart_interval, description: '5 Years' },
                ],
            };

            const tvWidget = new widget(widgetOptions);
            tvWidgetRef.current = tvWidget;

            tvWidget.onChartReady(() => {
                // console.log('Chart has loaded!');
                setSymbol(props.symbolCode);
                addCustomButton(tvWidget);

                const container = document.getElementById('tradingview');
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        mutation.addedNodes.forEach((node) => {
                            if (node.nodeName === 'IFRAME') {
                                node.addEventListener('load', () => {
                                });
                                observer.disconnect();
                            }
                        });
                    });
                });

                observer.observe(container, { childList: true, subtree: true });


            });


            return () => {
                tvWidget.remove();
            };

        },
        [theme, currentTheme, props.symbolCode]
    );

    const addCustomButton = (chart) => {
        chart.headerReady().then(() => {
            const buttonOptions = {
                title: 'Sembol/Hisse Ara',
                align: 'right',  // Sağa hizalama opsiyonu
                icon: '<FontAwesomeIcon icon={faXmark} />',
            };
            const button = chart.createButton(buttonOptions);
            button.setAttribute('title', 'Sembol/Hisse Ara');
            button.classList.add('apply-common-tooltip');
            button.addEventListener('click', () => setVisible(true));
            // button.textContent = 'Sembol/Hisse Ara';

            button.innerHTML = '<FontAwesomeIcon icon={faXmark} />  Sembol/Hisse Ara';

            setTimeout(() => {
                const iframe = document.querySelector('iframe');
                if (iframe) {

                    const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
                    const fullscreenButton = iframeDocument.querySelector('[data-name="header-toolbar-fullscreen"]')
                    const seperator = iframeDocument.querySelector('.separatorWrap-MBOVGQRI');
                    const clonedSeperator = seperator.cloneNode(true);
                    const customButton = iframeDocument.querySelector('.customButton-qqNP9X6e');
                    const clonedFullscreenButton = fullscreenButton.cloneNode(true);

                    if (customButton) {
                        if (clonedFullscreenButton) customButton.parentNode.insertBefore(clonedFullscreenButton, customButton.nextSibling);
                        if (clonedSeperator) customButton.parentNode.insertBefore(clonedSeperator, customButton.nextSibling);
                        if (customButton) {
                            // İkonu içeren yeni bir <i> elementi yarat
                            const icon = iframeDocument.createElement('i');
                            icon.className = 'fas fa-search'; // FontAwesome 5 için arama ikonu
                            customButton.prepend(icon); // İkonu metnin önüne ekler
                            const textNode = iframeDocument.createTextNode(' ');
                            customButton.insertBefore(textNode, icon.nextSibling);
                        }
                    }

                    if (fullscreenButton) fullscreenButton.parentNode.removeChild(fullscreenButton);

                    const separatorWrap = iframeDocument.querySelector('[data-is-fake-main-panel="false"] > .wrapOverflow-wXGVFOC9 > .wrap-wXGVFOC9 > .scrollWrap-wXGVFOC9 > .content-OhqNVIYA > .innerWrap-OhqNVIYA > :nth-child(10) ');
                    if (separatorWrap) separatorWrap.remove();

                    const separatorWrap2 = iframeDocument.querySelector('[data-is-fake-main-panel="false"] > .wrapOverflow-wXGVFOC9 > .wrap-wXGVFOC9 > .scrollWrap-wXGVFOC9 > .content-OhqNVIYA > .innerWrap-OhqNVIYA > :nth-child(11) ');
                    if (separatorWrap2) separatorWrap2.remove();

                    const head = iframeDocument.head;
                    const link = iframeDocument.createElement('link');
                    link.type = 'text/css';
                    link.rel = 'stylesheet';
                    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css';
                    head.appendChild(link);
                    if (clonedFullscreenButton) {
                        clonedFullscreenButton.addEventListener('click', function () {
                            chart.startFullscreen();
                        });
                    }

                } else {
                    console.log('Iframe not found');
                }
            }, 100);
        });
    }

    // Dövizlerin günlük history'sinde sadece close değeri var (O=H=L=C), mum düz çizgi görünüyor.
    // ERT'deki gibi currency sembollerinde Line (2), diğerlerinde Candle (1) ile açıyoruz.
    const applyChartTypeForSymbol = () => {
        const chart = tvWidgetRef.current.activeChart();
        const symbolType = chart.symbolExt()?.type;
        const chartType = symbolType === 'currency' ? 2 : 1;
        if (chart.chartType() !== chartType) chart.setChartType(chartType);
    };

    const setSymbol = (symbol) => {
        setIsLoadingTable(true); // Spinner’ı göster
        if (!symbol) symbol = 'null';

        const chartSymbol = tvWidgetRef.current.chart().symbol();
        if (chartSymbol !== symbol) {
            tvWidgetRef.current.setSymbol(symbol, chart_interval, () => {
                applyChartTypeForSymbol();
                setIsLoadingTable(false); // Sembol yüklendiğinde spinner’ı gizle
            });
        } else {
            setIsLoadingTable(false);
        }
    };

    const selectedPageSearchItem = (item) => {
        try {
            console.log('item selectedPageSearchItem: ', item);
            setSymbol(item.document.objectId);

        } catch (error) {
            console.log('props.selectedPageSearchItem: ' + error);
        }
    };

    const handleRowClick = (item) => {
        handleClose();
        setSymbol(item.document.objectId);
        setSearchValue("");
    };

    return (
        <>
            <div style={{ height: "700px", width: props.width, float: 'right', position: "relative" }}>
                {isLoadingTable && (
                    <div className="backdrop">
                        <Spinner /> {/* Spinner, yükleme sırasında görünür */}
                    </div>
                )}
                <div
                    ref={chartContainerRef}
                    id="tradingview"
                    style={{
                        height: "100%",
                        width: "100%",
                        filter: isLoadingTable ? "blur(3px)" : "none",
                    }}
                />
            </div>

            <Modal show={visible} onHide={handleClose}
                className='searchTWModal'
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header className='searchTWModalHeader'>
                    {/* <Modal.Title>Modal heading</Modal.Title> */}
                    <Container className='container'>
                        <Row className='columnsSelectHeaderRow cursor-pointer'>
                            <Col md="11" className='header-text roboto-regular-18 p-0'>Sembol/Hisse Ara</Col>
                            <Col md="1"><FontAwesomeIcon className='modalCloseIcon text-align-right float-right cursor-pointer p-0' icon={faXmark} onClick={handleClose} /></Col>
                        </Row>
                    </Container>
                </Modal.Header>

                <Modal.Body className='searchTWModalBody'>
                    <Search ref={searchInputRef} selectedSearchItem={handleRowClick} />
                </Modal.Body>
            </Modal>

        </>
    );



}
